'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  color: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  @media (max-width: 991px) {\n    ", "\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  }\n\n  @media (max-width: 767px) {\n    ", "\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  }\n"], ["\n  color: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  @media (max-width: 991px) {\n    ", "\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  }\n\n  @media (max-width: 767px) {\n    ", "\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n  }\n"]);

var textStyle = styled.css(_templateObject, function (props) {
  return props.color ? props.color : "inherit";
}, function (props) {
  return props.bold && "font-weight: bold";
}, function (props) {
  return props.semiBold && "font-weight: 600";
}, function (props) {
  return props.light && "font-weight: 300";
}, function (props) {
  return props.weight && "font-weight: " + props.weight;
}, function (props) {
  return props.opacity && "opacity: " + props.opacity;
}, function (props) {
  return props.fontStyle && "font-style: " + props.fontStyle;
}, function (props) {
  return props.size && "font-size: " + props.size;
}, function (props) {
  return props.lineHeight && "line-height: " + props.lineHeight;
}, function (props) {
  return props.leftSpace && "margin-left: " + props.leftSpace;
}, function (props) {
  return props.rightSpace && "margin-right: " + props.rightSpace;
}, function (props) {
  return props.margin && "margin: " + props.margin;
}, function (props) {
  return props.mt && "margin-top: " + props.mt + "px";
}, function (props) {
  return props.mb && "margin-bottom: " + props.mb + "px";
}, function (props) {
  return props.mr && "margin-right: " + props.mr + "px";
}, function (props) {
  return props.ml && "margin-left: " + props.ml + "px";
}, function (props) {
  return props.m0 && "margin: 0px";
}, function (props) {
  return props.maxWidth && "max-width: " + props.maxWidth;
}, function (props) {
  return props.align && "text-align: " + props.align;
}, function (props) {
  return props.lineThrough && "text-decoration: line-through";
}, function (props) {
  return props.underline && "text-decoration: underline";
}, function (props) {
  return props.decoration && "text-decoration: " + props.decoration;
}, function (props) {
  return props.center && "text-align: center";
}, function (props) {
  return props.letterSpacing && "letter-spacing: " + props.letterSpacing + "px";
}, function (props) {
  return props.padding && "padding: " + props.padding;
}, function (props) {
  return props.hideDesktop && "display: none";
}, function (props) {
  return props.display ? "display:" + props.display : "";
}, function (props) {
  return props.width && "width: " + props.width;
}, function (props) {
  return props.display ? "display:" + props.display : "";
}, function (props) {
  return props.tColor && "color: " + props.tColor;
}, function (props) {
  return props.tSize && "font-size: " + props.tSize;
}, function (props) {
  return props.tWeight && "font-weight: " + props.tWeight;
}, function (props) {
  return props.tMargin && "margin: " + props.tMargin;
}, function (props) {
  return props.tLineHeight && "line-height: " + props.tLineHeight;
}, function (props) {
  return props.tCenter && "text-align: center";
}, function (props) {
  return props.hideDesktop && "display: initial";
}, function (props) {
  return props.hideMobile && "display: none";
}, function (props) {
  return props.tWidth && "width: " + props.tWidth;
}, function (props) {
  return props.display ? "display:" + props.display : "";
}, function (props) {
  return props.mColor && "color: " + props.mColor;
}, function (props) {
  return props.mSize && "font-size: " + props.mSize;
}, function (props) {
  return props.mWeight && "font-weight: " + props.mWeight;
}, function (props) {
  return props.mMargin && "margin: " + props.mMargin;
}, function (props) {
  return props.mLineHeight && "line-height: " + props.mLineHeight;
}, function (props) {
  return props.mCenter && "text-align: center";
}, function (props) {
  return props.hideDesktop && "display: initial";
}, function (props) {
  return props.hideMobile && "display: none";
}, function (props) {
  return props.mWidth && "width: " + props.mWidth;
});

exports.textStyle = textStyle;
//# sourceMappingURL=style-222d2b0f.js.map
